module.exports = __webpack_public_path__ + "static/img/doc_methodecalcul_consohoraire.892cab2c.png";